import api from 'api';
import { actions } from 'store';
import { useDispatch, useReduxState } from 'hooks';
import { ModalButtonWithForm } from 'components/common';
import { Code, FormGroup, FormSection } from 'components/common/form';

import type { GetUserCustomAttributesRes } from 'shared-types/responses';
import type { UserAttributesAttributeFormState } from './UserAttributesAttributeForm';

interface Props {
  attribute: GetUserCustomAttributesRes['userCustomAttributes'][0];
  isDropdown?: boolean;
  updateData: () => Promise<void>;
}

const UserAttributesEditLimited = ({
  attribute,
  isDropdown,
  updateData
}: Props) => {
  const { dispatch } = useDispatch();

  const { messages } = useReduxState();

  const handleSubmit = async (values: UserAttributesAttributeFormState) => {
    const data = {
      validation: values.validation
        ? {
            matchList: values.validation.matchList
              ?.split('\n')
              .filter((option) => option.trim())
              .map((option) => option)
          }
        : null
    };

    await api.put(`/admin/user-custom-attributes/${attribute.id}`, data);

    await updateData();

    dispatch(
      actions.addNotice({
        text: messages.attributesEditSuccess,
        type: 'success'
      })
    );
  };

  const initialValues = {
    validation: {
      matchList: attribute.validation?.matchList?.join('\n')
    }
  };

  return (
    <ModalButtonWithForm
      buttonCategory="default"
      buttonIcon="pen"
      buttonIsDropdown={Boolean(isDropdown)}
      buttonSize="header"
      buttonText={messages.commonEdit}
      contentStyle={{ padding: 0 }}
      formAllowEmptyStrings={true}
      initialValues={initialValues}
      modalActionCategory="success"
      modalActionText={messages.commonSaveChanges}
      modalTitle={messages.attributesEdit}
      modalWidth="wide"
      onSubmit={handleSubmit}
    >
      {() => (
        <div>
          {attribute.type === 'String' ? (
            <FormSection title={messages.commonValidation}>
              <FormGroup
                label={messages.attributesValidationMatchList}
                maxWidth="400px"
              >
                <Code
                  field="validation.matchList"
                  placeholder={'item1\nitem2\nitem3'}
                />
              </FormGroup>
            </FormSection>
          ) : null}
        </div>
      )}
    </ModalButtonWithForm>
  );
};

export default UserAttributesEditLimited;
